export enum CapabilityEnum {
  list = "main.list",
  general = "general",
  generalCommission = "general.commission",
  generalExport = "general.export",
  detail = "detail",
  create = "create",
  update = "update",
  delete = "delete",
  download = "download",
  exportExcel = "export",
  filterPrefix = "filter.",
  phoneFilter = "filter.phoneNumber",
  nameFilter = "filter.name",
  emailFilter = "filter.email",
  codeFilter = "filter.code",
  refFilter = "filter.ref",
  statusFilter = "filter.status",
  typeFilter = "filter.type",
  partnerFilter = "filter.partner",
  storeFilter = "filter.store",
  platformFilter = "filter.platform",
  userFilter = "filter.user",
  dateFilter = "filter.date",
  carrierFilter = "filter.carrier",
  permissionFilter = "filter.permission",
  supplierFilter = "filter.supplier",
  packageFilter = "filter.package",
  staffFilter = "filter.staff",
  searchAndRedoFilter = "filter",
  airTimeFilter = "filter.airtime",
  zodiacFilter = "filter.zodiac",
  destinyFilter = "filter.destiny",
  numerologyFilter = "filter.numerology",
  numberTypeFilter = "filter.skus",
  nationFilter = "filter.nation",
  serviceFilter = "filter.service",
  userStoreMain = "user.store.main.list",
  userStaffMain = "user.staff.main.list",
  userChainMain = "user.chain.main.list",
  userChainFilter = "filter.user.chain",
  userStoreFilter = "filter.user.store",
  systemUserFilter = "filter.system.user",
  privateTransList = "private.main.list",
  privateTransDetail = "private.trans.detail"
}
